<div class="container">
  @if (value) {
    <div class="circle">
      {{ value }}
    </div>
  }
</div>
